export default __webpack_public_path__ + "static/media/sticker-Z.c245f310.png";